var React = require('react');

function UserNurse (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128.59,320Zm190.82,0ZM304,160v16a80,80,0,0,1-160,0V160H96v16a128,128,0,0,0,256,0V160Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M144,160H352V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V160Zm40-88.33a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320Z","className":"fa-primary","key":2})]);
}

UserNurse.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = UserNurse;

UserNurse.default = UserNurse;
